<template lang="html">
  <div class="content">
    <h3>Informações Básicas</h3>
    <b-field label="Qual sua cidade?">
      <b-select v-model="cityCode" placeholder="Selecione uma cidade" required expanded>
        <option :value="c.cod_cidade" v-for="(c, index) in cities" :key="index">{{ c.nome }}</option>
        <option value="0">Minha cidade não consta na lista...</option>
      </b-select>
    </b-field>
    <b-field label="Qual tipo de atividade sua empresa desempenha?">
      <b-select v-model="activityCode" placeholder="Selecione uma atividade" required expanded>
        <option value="0">Industria</option>
        <option value="1">Comércio</option>
        <option value="2">Serviço</option>
      </b-select>
    </b-field>
    <b-field label="Quantos sócios terá sua empresa?">
      <b-input type="number" min="0" :max="partners.max" v-model="partnersQtd" placeholder="Número de sócios" required></b-input>
    </b-field>
    <b-field label="Sua empresa terá funcionários?">
      <b-input type="number" min="0" :max="employees.max" v-model="employeesQtd" placeholder="Número de sócios" required></b-input>
    </b-field>
    <b-field label="Qual o seu faturamento previsto?">
      <b-select v-model="revenue" placeholder="Selecione um faturamento previsto" required expanded>
        <option :value="index" v-for="(r, index) in revenues" :key="index">De R$ {{ r.valor_inicial | currency }} á  R$ {{ r.valor_final | currency }}/mês</option>
      </b-select>
    </b-field>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'basicInfo',
  data () {
    return {
    }
  },
  beforeMount () {
  },
  computed: {
    ...mapGetters([
      'cities',
      'revenues',
      'employees',
      'partners'
    ]),
    cityCode: {
      get () {
        return this.$store.getters.form.cityCode
      },
      set (newVal) {
        this.setFormState(['cityCode', newVal])
      }
    },
    activityCode: {
      get () {
        return this.$store.getters.form.activityCode
      },
      set (newVal) {
        this.setFormState(['activityCode', newVal])
      }
    },
    partnersQtd: {
      get () {
        return this.$store.getters.form.partnersQtd
      },
      set (newVal) {
        this.setFormState(['partnersQtd', newVal])
      }
    },
    employeesQtd: {
      get () {
        return this.$store.getters.form.employeesQtd
      },
      set (newVal) {
        this.setFormState(['employeesQtd', newVal])
      }
    },
    revenue: {
      get () {
        return this.$store.getters.form.revenue
      },
      set (newVal) {
        this.setFormState(['revenue', newVal])
      }
    }
  },
  mounted () {},
  methods: {
    ...mapActions([
      'setFormState'
    ]),
    activityCodeParser (index) {
      let keys = [
        'mensalidade_industria',
        'mensalidade_comercio',
        'mensalidade_servico'
      ]
      return keys[index]
    }
  },
  components: {
  }
}
</script>
<style lang="scss" type="text/css" media="screen"></style>
